import { render, staticRenderFns } from "./product-standards-by-province.vue?vue&type=template&id=40c95582&scoped=true"
import script from "./product-standards-by-province.vue?vue&type=script&lang=js"
export * from "./product-standards-by-province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c95582",
  null
  
)

export default component.exports